import React, { useContext } from "react";
import { multiStepContext } from "../StepContext";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const DisplayData = () => {
  const { finalData } = useContext(multiStepContext);
  console.log(finalData);
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>First Name</TableCell>
            <TableCell >Last Name</TableCell>
            <TableCell >Contact</TableCell>

            <TableCell >Packge</TableCell>
            <TableCell > Package Charge</TableCell>

            <TableCell >Add Package 1</TableCell>
            <TableCell >Add Charge 1</TableCell>
            <TableCell >Add Package 2</TableCell>
            <TableCell >Add Charge 2</TableCell>
            <TableCell >Add Package 3</TableCell>
            <TableCell >Add Charge 3</TableCell>
            <TableCell >Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {finalData.map((data) => (
            <TableRow
              key={data.email}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell >{data.firstName}</TableCell>
              <TableCell >{data.lastName}</TableCell>
              <TableCell >{data.contact}</TableCell>

              <TableCell >
                {data.name1 || data.name2 || data.name3}
              </TableCell>
              <TableCell >
                {data.price1 || data.price2 || data.price3}
              </TableCell>

            
              <TableCell >{data.Name1}</TableCell>
              <TableCell >{data.option1}</TableCell>

              <TableCell >{data.Name2}</TableCell>
              <TableCell >{data.option2}</TableCell>

              <TableCell >{data.Name3}</TableCell>
              <TableCell >{data.option3}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DisplayData;
